module.exports = __webpack_public_path__ + "img/forehead.6627af7d.svg";